import React from "react";
import { FiCpu, FiGlobe, FiAward } from "react-icons/fi";
import "./ServicesSection.css";
import { useTranslation } from "react-i18next";

function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section className="services-section">
      <p className="subtitle">
        {t("services.subtitle_start")}{" "}
        <span className="gradient-text">{t("services.subtitle_span")}</span>
      </p>

      <div className="services-grid">
        {/* Carte 1 : Technologie */}
        <div className="service-card">
          <div className="icon-wrapper cyan-glow">
            <FiCpu />
          </div>
          <p>
            {t("services.card1_start")}{" "}
            <span className="highlight">{t("services.card1_span")}</span>{" "}
            {t("services.card1_end")}
          </p>
        </div>

        {/* Carte 2 : Réseau */}
        <div className="service-card">
          <div className="icon-wrapper purple-glow">
            <FiGlobe />
          </div>
          <p>
            {t("services.card2_start")}{" "}
            <span className="highlight">{t("services.card2_span")}</span>{" "}
            {t("services.card2_end")}
          </p>
        </div>

        {/* Carte 3 : Club */}
        <div className="service-card">
          <div className="icon-wrapper gold-glow">
            <FiAward />
          </div>
          <p>
            {t("services.card3_start")}{" "}
            <span className="highlight">{t("services.card3_span")}</span>
            {t("services.card3_end")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
